module.exports = __webpack_public_path__ + "static/FlowExample-5027b938ccf86cbf6304d1ecbb79b9fe.jpg";